import React from 'react';
import { Link } from 'react-router-dom';
import { newsData } from '../data/newsData';
export const HeroSection = () => {
  // Use the first article for the hero section
  const heroArticle = newsData[0];
  const heroArticleId = 0;
  return <section className="mb-12" data-id="element-168">
      <Link to={`/article/${heroArticleId}`} data-id="element-169">
        <div className="relative" data-id="element-170">
          <img src="https://images.unsplash.com/photo-1557862921-37829c790f19?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1200&q=80" alt="Global leaders meeting at climate summit" className="w-full h-[400px] object-cover rounded-lg" data-id="element-171" />
          <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-6 rounded-b-lg" data-id="element-172">
            <span className="inline-block bg-red-600 text-white px-2 py-1 text-sm font-medium rounded mb-2" data-id="element-173">
              BREAKING
            </span>
            <h2 className="text-2xl md:text-3xl font-bold text-white mb-2 hover:text-blue-200 transition-colors" data-id="element-174">
              {heroArticle.title}
            </h2>
            <p className="text-white text-opacity-90 mb-2" data-id="element-175">
              {heroArticle.excerpt}
            </p>
            <div className="flex items-center text-white text-opacity-75 text-sm" data-id="element-176">
              <span className="mr-4" data-id="element-177">By {heroArticle.author}</span>
              <span data-id="element-178">{heroArticle.date}</span>
            </div>
          </div>
        </div>
      </Link>
    </section>;
};